<template>
    <div class="my-account-block restricted-area p-4 mb-4">
        <h3 class="restricted-area-title"> Minha conta </h3>
        <hr class="mt-0">
        <div>
            <div v-for="(item, index) in menu" :key="index" class="d-flex justify-content-between align-items-baseline mb-3">
                <nuxt-link :to="item.url" :title="item.title" class="restricted-area-link" :class="$route.path.includes(item.url) ? 'isActive' : ''" >{{ item.title }}</nuxt-link>
                <div v-if="$route.path.includes(item.url)">
                    <b-icon icon="caret-right-fill" :class="$route.path.includes(item.url) ? 'icon-active' : ''"></b-icon>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    computed: {
        menu() {
            let items = []
            items.push({
                'title': 'Meus dados',
                'url': '/conta/meus-dados/',
                'isActive': false,
            })
            items.push({
                'title': 'Alterar senha',
                'url': '/conta/senha/',
                'isActive': false,
            })
            items.push({
                'title': 'Meus pedidos',
                'url': '/conta/pedidos/',
                'isActive': false,
            })
            if (this.$wdconfig.modules.gift_list && this.$wdconfig.modules.gift_list.active) {
                items.push({
                    'title': 'Lista de presentes',
                    'url': '/conta/lista-de-presentes/',
                    'isActive': false,
                })
            }
            items.push({
                'title': 'Sair',
                'url': '/logout',
                'isActive': false,
            })
            return items
        }
    }
}
</script>
